import {IoMdClose} from 'react-icons/io';

const Chip = ({item, color, remove}) => {
  return (
    <div
      className={`flex items-center ${color} py-2 px-4 font-medium tracking-wide`}
    >
      {item?.label || item}
      {remove && (
        <IoMdClose
          size={30}
          onClick={() => remove(item?.id || item)}
          className="ml-2 cursor-pointer"
        />
      )}
    </div>
  );
};

export default Chip;
